module.exports = " <div class=main :class=\"{ 'isDisconnected': user == null }\" _v-05d50fae=\"\"> <title-bar class=titlebar :class=\"{ 'isDisconnected': user == null }\" _v-05d50fae=\"\"></title-bar> <router-view class=view :class=\"{ 'view--hidden': submenu != false }\" _v-05d50fae=\"\"></router-view> <menu-bar class=menubar :class=\"{ 'isDisconnected': user == null }\" _v-05d50fae=\"\"></menu-bar> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-05d50fae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 314
// module chunks = 2